import { authFetch } from '../../utils/authFetch';
// src/redux/actions/templateActions.js
// Redux actions for managing assessment templates from Supabase

// Action types
export const FETCH_TEMPLATE_START = 'FETCH_TEMPLATE_START';
export const FETCH_TEMPLATE_SUCCESS = 'FETCH_TEMPLATE_SUCCESS';
export const FETCH_TEMPLATE_FAILURE = 'FETCH_TEMPLATE_FAILURE';

export const FETCH_ALL_TEMPLATES_START = 'FETCH_ALL_TEMPLATES_START';
export const FETCH_ALL_TEMPLATES_SUCCESS = 'FETCH_ALL_TEMPLATES_SUCCESS';
export const FETCH_ALL_TEMPLATES_FAILURE = 'FETCH_ALL_TEMPLATES_FAILURE';

/**
 * Fetch a single template by ID
 * @param {string} templateId - Template UUID
 * @returns {Function} Thunk action
 */
export const fetchTemplate = (templateId) => async (dispatch) => {
  dispatch({ type: FETCH_TEMPLATE_START });

  try {
    console.log('[templateActions] Fetching template:', templateId);

    const response = await authFetch('/.netlify/functions/templates-getTemplate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ templateId })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch template');
    }

    const data = await response.json();

    console.log('[templateActions] Template fetched successfully:', data.template?.name);

    dispatch({
      type: FETCH_TEMPLATE_SUCCESS,
      payload: {
        templateId,
        template: data.template
      }
    });

    return data.template;
  } catch (error) {
    console.error('[templateActions] Error fetching template:', error);
    dispatch({
      type: FETCH_TEMPLATE_FAILURE,
      payload: error.message
    });
    throw error;
  }
};

/**
 * Fetch all available templates (published only)
 * Used for template selection UI
 * @param {Object} filters - Optional filters
 * @param {string} filters.modelType - Filter by model type
 * @param {boolean} filters.publishedOnly - Only fetch published templates (default: true)
 * @returns {Function} Thunk action
 */
export const fetchAllTemplates = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ALL_TEMPLATES_START });

  try {
    console.log('[templateActions] Fetching all templates with filters:', filters);

    const response = await authFetch('/.netlify/functions/templates-listTemplates', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        published: filters.publishedOnly !== false, // Default to true
        modelType: filters.modelType || null
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch templates');
    }

    const data = await response.json();

    console.log('[templateActions] Fetched', data.templates?.length || 0, 'templates');

    dispatch({
      type: FETCH_ALL_TEMPLATES_SUCCESS,
      payload: data.templates || []
    });

    return data.templates;
  } catch (error) {
    console.error('[templateActions] Error fetching templates:', error);
    dispatch({
      type: FETCH_ALL_TEMPLATES_FAILURE,
      payload: error.message
    });
    throw error;
  }
};
